import { render, staticRenderFns } from "./SearchTree.vue?vue&type=template&id=ebd837bc&scoped=true&"
import script from "./SearchTree.vue?vue&type=script&lang=js&"
export * from "./SearchTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebd837bc",
  null
  
)

export default component.exports